type ButtonVariant = "brand" | "error" | "neutral";

interface IButtonProps {
    id?: string;
    dataCy?: string;
    label?: string;
    variant?: ButtonVariant;
    /**
     * @deprecated
     * Use variant="brand" for "btn btn-primary"
     */
    className?: string;
    disabled?: boolean;
    /**
     * @deprecated Use disabled instead
     */
    IsDisabled?: boolean;
    onClick?: (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
}

const variantStyleMapper: { [key in ButtonVariant]: string } = {
    "brand": "btn btn-primary",
    "error": "btn btn-danger",
    "neutral": "btn btn-default"
};

class ButtonControl extends React.Component<IButtonProps, never> {
    public render(): JSX.Element {
        const classname = this.props.className ?? "";

        return (
            <button
                id={this.props.id}
                data-cy={this.props.dataCy}
                disabled={this.props.disabled || this.props.IsDisabled}
                className={this.props.variant ? variantStyleMapper[this.props.variant] : classname}
                onClick={e => this.props.onClick?.(e)}
            >
                {this.props.label}
            </button>
        );
    }
}

export { ButtonControl, IButtonProps };
